import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { Circles } from 'react-loader-spinner';
import './AdminReport.css';
import privateAxios from '../../utils/axios/privateAxios';
import moment from 'moment';

import { Document, Page, pdfjs } from 'react-pdf';

// ✅ Set up the PDF worker properly
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const AdminReport = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const response = await privateAxios.get(`/private/admin-report/${id}`);
        setReport(response.data.report);
      } catch (error) {
        console.error('Error fetching report', error);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [id]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          alignItems: 'center',
          justifyContent: 'center',
          height: '300px',
          color: 'gray',
        }}
      >
        <Circles height="50" width="50" color="#008751" ariaLabel="loading" />
        <h2>Loading Report...</h2>
      </div>
    );
  }

  if (!report) return <div className="admin-report-error">Report not found.</div>;

  return (
    <div className="admin-report">
      {/* Header */}
      <div className="admin-report-header">
        <h1>{report.title}</h1>
        <p className="admin-report-meta">
          Posted By: {report.createdBy?.firstname} {report.createdBy?.lastname} | On:{' '}
          {moment(report.createdAt).format('MMMM DD, YYYY')}
          {report.updatedAt && ` | Last Edited: ${moment(report.updatedAt).format('MMMM DD, YYYY')}`}
        </p>
      </div>

      {/* PDF Section (Scrollable, Normal Render) */}
      {report.pdfUrl && (
        <div className="admin-report-pdf-wrapper">
          <Document
            file={report.pdfUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<div>Loading PDF...</div>}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <div key={`page_${index + 1}`} className="pdf-page">
                <Page
                  pageNumber={index + 1}
                  renderAnnotationLayer={true}
                  renderTextLayer={true}
                  width={Math.min(window.innerWidth - 10, 800)}
                />
              </div>
            ))}
          </Document>
        </div>
      )}

      {/* Report Content */}
      <div
        className="admin-report-content"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(report.content) }}
      ></div>

      {/* Actions */}
      <div className="admin-report-actions">
        <button onClick={() => navigate(`/admin-edit-report/${id}`)}>Edit Report</button>
        <button onClick={() => navigate('/admin-reports')}>Back to Reports</button>
      </div>
    </div>
  );
};

export default AdminReport;